module.exports = __webpack_public_path__ + "static/smartpay_21-retail-cc35f5e25c45e93463cf0369c840338e.svg";